import React, { memo } from 'react'

import { Button, Icon, Trash } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  bool, func, number, shape, string,
} from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const trashIcon = <Icon svgComponent={Trash} size={iconSize} color="dark" notSpaced />

function SelectedStyle({
  style,
  isStylePanelOpen,
  onTogglePanel,
  onRemove,
}) {
  const t = useTranslation()

  return (
    <div className="render-tab__style-field render-tab__style-field--selected">
      <button
        type="button"
        aria-expanded={isStylePanelOpen}
        className="render-tab__style-select"
        onClick={onTogglePanel}
      >
        <img className="render-tab__style-thumb" src={style.image_url} alt="" decoding="async" />
        <span className="render-tab__style-name cgt-body-base-semibold">{style.name}</span>
      </button>
      <Button
        type="ghost"
        variant="only-icon"
        size="tiny"
        actionType="button"
        icon={trashIcon}
        aria-label={t('viewerSidebar.enhance.render.styleRemove', { name: style.name })}
        onClick={() => onRemove(style.id)}
      />
    </div>
  )
}

SelectedStyle.propTypes = {
  style: shape({
    id: number.isRequired,
    name: string.isRequired,
    image_url: string.isRequired,
  }).isRequired,
  isStylePanelOpen: bool.isRequired,
  onTogglePanel: func.isRequired,
  onRemove: func.isRequired,
}

export default memo(SelectedStyle)
